import { connect } from 'react-redux';
import { deleteSmartAction } from '../smart-action-sidepanel/smart-action-sidepanel-actions';
import { getTicketActionTypes } from '../form/ticket-form-actions';
import SmartActionSection from '../../components/form/smart-action-section';

const mapStateToProps = (state) => {
  const {
    ticketForm: {
      actionTypes,
      actions,
      followUpTypes,
    },
    smartAction: { isDeleting, deleteSuccess, deleteError },
  } = state;

  return {
    isDeleting,
    deleteSuccess,
    deleteError,
    actions,
    actionTypes,
    followUpTypes,
  };
};

const mapDispatchToProps = {
  deleteSmartAction,
  getTicketActionTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartActionSection);
